import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { supabase } from '@/lib/supabase'
import { fetchProfilesData } from '@/lib/api/helpers'
import { mutationErrorHandler } from '@/lib/utils'

export type Profile = { id: string; display_name: string; avatar_url: string | null }

export function useProfiles() {
  return useQuery<Profile[]>({
    queryKey: ['profiles'],
    queryFn: fetchProfilesData,
  })
}

export function useUpdateProfile() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ userId, displayName }: { userId: string; displayName: string }) => {
      const { error } = await supabase
        .from('profiles')
        .update({ display_name: displayName })
        .eq('id', userId)
      if (error) throw error
    },
    onSuccess: () => {
      toast.success('表示名を更新しました')
      queryClient.invalidateQueries({ queryKey: ['profiles'] })
    },
    onError: mutationErrorHandler('更新に失敗しました'),
  })
}
